import {Component, Prop, Vue, Emit, Watch} from 'vue-property-decorator';
import common from '../../../../common/src/assets/js/common';
import Service from '../../../../common/src/assets/service/service';
import environment from '../../../../common/src/assets/environment/environment';

@Component
export default class HeaderNav extends Vue {
    $store: any;
    $router: any;
    $window: any;
    private userInfo:any = {};
    private verifyUrl:any = '';

    @Watch('$store.state.userInfo', {immediate: true})
    getUserInfo(val: any) {
        if (val) {
            this.userInfo = val;
            this.verifyUrl = (this.userInfo.personVeriyed === 1 || this.userInfo.companyVeriyed === 1) ? 
            '/authenticationinfo' : '/authentication';
        }
    }
    @Watch('$store.state.systemInfo', {immediate: true})
    getSystemInfo(val: any) {
        if (val) {
            let url = environment.apiPrefix + '/common/GetStaticPic?path=';
            this.companyLogo = val.companyLogo ? url + this.tidyUrl(val.companyLogo) : 
            (val.siteLogo ?  url + this.tidyUrl(val.siteLogo) : '');
            this.siteLogo = val.siteLogo ? url + this.tidyUrl(val.siteLogo) : '';
            this.siteName = val.siteName ? val.siteName : '';
            this.status.logo = this.companyLogo ? 'havedata' : 'nodata';
            this.change_icon();
        }
    }
    private product: any = {
        vm: {
            name: '云服务器管理', list: [
                {name: "创建云服务器", url: "/resource/vm/create"},
                {name: "云服务器管理", url: "/resource/vm/list"},
            ],
        },
        storage: {
            name: '云存储管理', list: [
                {name: "镜像管理", url: "/resource/mirror/list"},
                {name: "云磁盘管理", url: "/resource/disk/list"},
                {name: "云快照备份", url: "/resource/snap/list"},
                // {name: "RDS数据库", url: ""},
            ],
        },
        safety: {
            name: '云安全中心', list: [
                {name: "安全组管理", url: "/resource/securityGroup/list"},
            ],
        },
        network: {
            name: '云网络管理', list: [
                {name: "弹性公网IP", url: "/resource/ip/list"},
                {name: "VPC虚拟私有云", url: "/resource/vpc/list"},
                {name: "虚拟交换机", url: "/resource/vswitch/list"},
                {name: "VPC路由表", url: "/resource/route/list"},
                {name: "NAT网关", url: "/resource/nat/list"},
                // {name: "共享带宽包", url: ""},
            ],
        },
        slb: {
            name: '负载均衡管理', list: [
                {name: "创建负载均衡", url: "/resource/slb/create"},
                {name: "负载均衡管理", url: "/resource/slb/list"},
            ],
        },
    }
    private email: string = '';
    showProduct: any = false;
    private companyLogo: string = '';
    private siteLogo: string = '';
    private siteName: string = '';
    private status: any = {
        logo: 'loading'
    }
    private created() {
        this.email = common.getCookie('user') || '-';
        this.userInfo.email = this.email;
        if (this.userInfo) {
            this.verifyUrl = (this.userInfo.personVeriyed === 1 || this.userInfo.companyVeriyed === 1) ? 
            '/authenticationinfo' : '/authentication';
        }
    }

    mounted() {
        let productContent = document.getElementsByClassName('.product-container');
        let that = this;
        document.onclick = function(e) {
            that.showProduct = false;
        }
    }

    private skip(url: any) {
        this.$router.push(url)
    }

    private exit() {
        common.clearAllCookie();
        this.$router.push('/login');
    }

    private goToHome() {
        window.open(environment.exclusiveCloudIndex);
    }

    /**跳转到帮助文档 */
    private gotoHelpPage() {
        let host = window.location.host;
        host = host.split(':')[0];
        window.location.href = 'https://' + host + '/help';
    }
    private tidyUrl(url:any) {
        let imgitem = url;
        let imgUrl = imgitem && imgitem.split('/');
        if (imgUrl && imgUrl[1] !== 'upload') {
            // imgUrl = imgUrl.splice(2, imgUrl.length).join('/');
            imgUrl = '/upload' + url;
        } else {
            imgUrl = url;
        }
        return imgUrl;
    }
    /**动态修改站点图标 和 站点名称*/
    change_icon() {
        const changeFavicon = (link:any) => {
            let $favicon: any = document.querySelector('link[rel="icon"]');
            console.log('link[rel="icon', $favicon);
            if ($favicon !== null) {
                $favicon.href = link;
            } else {
                $favicon = document.createElement("link");
                $favicon.rel = "icon";
                $favicon.href = link;
                document.head.appendChild($favicon);
            }
        };
        // 设置站点名称
        let $siteTitle = document.getElementById('siteName');
        $siteTitle!.innerHTML = this.siteName;
        // 设置图标地址
        let iconUrl = this.siteLogo;
        // 动态修改网站图标
        changeFavicon(iconUrl);
    }
}
